import { render, staticRenderFns } from "./yxdealersub.vue?vue&type=template&id=6e1907cf&scoped=true&"
import script from "./yxdealersub.vue?vue&type=script&lang=js&"
export * from "./yxdealersub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1907cf",
  null
  
)

export default component.exports